"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedAppLoader = AuthenticatedAppLoader;
const hooks_1 = require("../../../ui/hooks");
const stores_1 = require("../../../ui/stores");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
/**
 * @deprecated
 */
function AuthenticatedAppLoader(props) {
    let loginUrl = '/platform/api/v1/oauth2/authorize/juvare_' + props.app;
    const localhost = getLocalhost();
    if (localhost) {
        loginUrl = 'http://' + localhost + ':8080' + loginUrl;
    }
    const appContext = react_1.default.useContext(props.appContext);
    const dispatch = (0, react_redux_1.useDispatch)();
    const userClient = (0, hooks_1.useUserClient)();
    const [loading, setLoading] = react_1.default.useState(true);
    react_1.default.useEffect(() => {
        let ignore = false;
        if (!appContext.currentUser) {
            setLoading(true);
            dispatch(stores_1.platformSlice.actions.setLoading());
            userClient
                .getUserState()
                .then((userState) => {
                if (!ignore) {
                    appContext.initState(userState);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    dispatch(stores_1.platformSlice.actions.setUser(userState));
                }
            })
                .catch((error) => {
                if (!ignore) {
                    dispatch(stores_1.platformSlice.actions.setError(error));
                }
            }) // do nothing
                .finally(() => {
                if (!ignore) {
                    setLoading(false);
                }
            });
        }
        return () => {
            ignore = true;
        };
    }, [appContext, userClient]);
    if (loading || props.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, props.loadingFallback());
    }
    else if (appContext.userState) {
        return react_1.default.createElement(react_1.default.Fragment, null, props.authenticated(appContext.userState));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, props.anonymous(loginUrl));
    }
}
function getLocalhost() {
    const host = window.location.host;
    if (/localhost(:\d+)?/.test(host) || /127\.0\.0\.1(:\d+)?/.test(host) || /::1(:\d+)?/.test(host)) {
        const i = host.indexOf(':');
        return i === -1 ? host : host.substring(0, i);
    }
    return undefined;
}
